import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Globe, Users, Building2, TrendingUp } from 'lucide-react';
import { globalNetwork } from '../data/mock';

export const GlobalNetwork = () => {
  return (
    <div className="service-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Global Network</span>
      </div>

      {/* Hero Section */}
      <section className="service-detail-hero">
        <div className="service-detail-icon">
          <Globe size={48} />
        </div>
        <h1 className="service-detail-title">Global Network</h1>
        <p className="service-detail-subtitle">
          Strategic relationships with family offices, institutional investors, developers and capital partners across key markets
        </p>
      </section>

      {/* Network Presence */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <h2 className="service-section-title">Global Presence</h2>
          <div className="network-grid">
            {globalNetwork.map((network, idx) => (
              <div key={idx} className="network-card">
                <h3 className="network-location">{network.location}</h3>
                <p className="network-description">{network.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Categories */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <h2 className="service-section-title">Network Partnerships</h2>
          <p className="service-section-text" style={{marginBottom: '48px'}}>
            HSNL Advisory maintains strategic working relationships with leading institutions and capital partners globally
          </p>
          
          <div className="partnership-grid">
            <div className="partnership-card">
              <div className="partnership-icon">
                <Users size={32} />
              </div>
              <h3 className="partnership-title">Family Offices</h3>
              <p className="partnership-text">
                Ultra HNI family offices across India, Middle East and global markets seeking strategic investments
              </p>
            </div>

            <div className="partnership-card">
              <div className="partnership-icon">
                <Building2 size={32} />
              </div>
              <h3 className="partnership-title">Institutional Investors</h3>
              <p className="partnership-text">
                PE funds, institutional capital and strategic investors focused on India and emerging markets
              </p>
            </div>

            <div className="partnership-card">
              <div className="partnership-icon">
                <TrendingUp size={32} />
              </div>
              <h3 className="partnership-title">Developers</h3>
              <p className="partnership-text">
                Leading real estate developers and infrastructure companies across India
              </p>
            </div>

            <div className="partnership-card">
              <div className="partnership-icon">
                <Globe size={32} />
              </div>
              <h3 className="partnership-title">Capital Partners</h3>
              <p className="partnership-text">
                Global investment banks, debt funds and strategic capital providers
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Capital Network Highlight */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="service-pipeline-highlight">
            <h2 className="pipeline-title">Global Capital Network</h2>
            <p className="pipeline-description-large">
              Our network includes investors, developers, family offices and capital partners across India, Middle East and global markets.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="service-cta-box">
            <h2 className="cta-title">Join Our Network</h2>
            <p className="cta-text">
              Connect with HSNL Advisory to explore partnership opportunities and access our global investor network.
            </p>
            <Link to="/#contact" className="btn-primary">
              Connect with Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
